import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const IndustrialDictionaryLayout = lazy(() => import('.'));
const One = lazy(() => import('./one'));
const Two = lazy(() => import('./two'));

export const routeConfig: (RouteProps & { subChildren?: RouteProps[] })[] = [
  {
    path: '/industrial-dictionary',
    element: <IndustrialDictionaryLayout />,
    subChildren: [
      { path: '/industrial-dictionary/one', element: <One /> },
      { path: '/industrial-dictionary/two/:id', element: <Two /> },
    ],
  },
];
